<template lang="html">


    <div class="container-fluid">
        <div v-if="previewsColisiones">
            <div class="my-2 mx-1">
                <v-btn color="error"
                       @click="regresar()"
                       dark
                       dense>
                    <v-icon left>
                        mdi-keyboard-backspace
                    </v-icon>
                    Regresar
                </v-btn>
            </div>

            <v-row v-if="tipo == 1">
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card class=" mx-1 pt-2 primary">
                        <center>
                            <v-list-item-title class="text-h5 mb-1 primary" color="white" style="color:white">
                                Colisiones Mayores
                            </v-list-item-title>
                        </center>

                    </v-card>
                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidios != 0" class="wrexlink" @click="previstaColisiones(1)" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresHomicidios}}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidios == 0" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresHomicidios}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="red">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidios != 0" class="wrexlink" @click="previstaColisiones(1)" style="font-size: 16px;  ">
                                        Homicidios
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidios == 0" style="font-size: 16px;  ">
                                        Homicidios
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesiones != 0" class="wrexlink" @click="previstaColisiones(2)" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresLesiones}}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesiones == 0" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresLesiones}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesiones != 0" class="wrexlink" @click="previstaColisiones(2)" style="font-size: 16px;  ">
                                        Lesiones
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesiones == 0" style="font-size: 16px;  ">
                                        Lesiones
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresDanios != 0" class="wrexlink" @click="previstaColisiones(3)" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresDanios}}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDanios == 0" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresDanios}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="yellow">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDanios != 0" class="wrexlink" @click="previstaColisiones(3)" style="font-size: 16px;  ">
                                        Daños
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDanios == 0" style="font-size: 16px;  ">
                                        Daños
                                    </span>
                                </v-row>

                            </v-col>
                        </v-row>


                        <br />

                    </v-card>

                </v-col>
            </v-row>

            <v-row v-if="tipo == 2">
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card class=" mx-1 pt-2 primary">
                        <center>
                            <v-list-item-title class="text-h5 mb-1 primary" color="white" style="color:white">
                                Colisiones Menores
                            </v-list-item-title>
                        </center>

                    </v-card>
                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMenoresJuicios != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMenores(3,'Juicios Orales','Colisiones-Menores')" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMenoresJuicios}}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMenoresJuicios == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMenoresJuicios}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMenoresJuicios != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMenores(3,'Juicios Orales','Colisiones-Menores')" style="font-size: 16px;  ">
                                        Juicios Orales
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMenoresJuicios == 0 || !permiso" style="font-size: 16px;  ">
                                        Juicios Orales
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMenoresAve != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMenores(4,'Averiguación Previa','Colisiones-Menores')" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMenoresAve}}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMenoresAve == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMenoresAve}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="red">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMenoresAve != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMenores(4,'Averiguación Previa','Colisiones-Menores')" style="font-size: 16px;  ">
                                        Averiguación Previa
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMenoresAve == 0 || !permiso" style="font-size: 16px;  ">
                                        Averiguación Previa
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMenoresJuez != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMenores(2,'Juez Cívico Conciliador','Colisiones-Menores')" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMenoresJuez}}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMenoresJuez == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMenoresJuez}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="yellow">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMenoresJuez != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMenores(2,'Juez Cívico Conciliador','Colisiones-Menores')" style="font-size: 16px;  ">
                                        Juez Cívico Conciliador
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMenoresJuez == 0 || !permiso" style="font-size: 16px;  ">
                                        Juez Cívico Conciliador
                                    </span>
                                </v-row>

                            </v-col>
                        </v-row>


                        <br />

                    </v-card>

                </v-col>
            </v-row>





            <v-row v-if="tipo == 3">
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card class=" mx-1 pt-2 primary">
                        <center>
                            <v-list-item-title class="text-h5 mb-1 primary" color="white" style="color:white">
                                Robos Recuperados
                            </v-list-item-title>
                        </center>

                    </v-card>
                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="6" sm="6">
                                <v-row justify="center">
                                    <span v-if="dataPendientesRobo.RobosRecuperadosVhDetenidos != 0 && permiso" class="wrexlink" @click="generarTableroRoboVHDetenidos(1,'Liberación de Vehículo','Robos-Recuperados')" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesRobo.RobosRecuperadosVhDetenidos}}
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosRecuperadosVhDetenidos == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesRobo.RobosRecuperadosVhDetenidos}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesRobo.RobosRecuperadosVhDetenidos != 0 && permiso" class="wrexlink" @click="generarTableroRoboVHDetenidos(1,'Liberación de Vehículo','Robos-Recuperados')" style="font-size: 16px;  ">
                                        Vehículos Detenidos
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosRecuperadosVhDetenidos == 0 || !permiso" style="font-size: 16px;  ">
                                        Vehículos Detenidos
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="6" sm="6">
                                <v-row justify="center">
                                    <span style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesRobo.RobosRecuperadosVhLiberados}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="red">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span style="font-size: 16px;  ">
                                        Vehículos Liberados
                                    </span>
                                </v-row>
                            </v-col>
                        </v-row>


                        <br />

                    </v-card>

                </v-col>
            </v-row>
        </div>








        <div v-if="!previewsColisiones">
            <div class="my-2 mx-1">
                <v-btn color="error"
                       @click="regresarPreColisiones()"
                       dark
                       dense>
                    <v-icon left>
                        mdi-keyboard-backspace
                    </v-icon>
                    Regresar
                </v-btn>
            </div>



            <!--HOMICIDIOS-->
            <v-row v-if="previewsHomicidios">
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card class=" mx-1 pt-2 primary">
                        <center>
                            <v-list-item-title class="text-h5 mb-1 primary" color="white" style="color:white">
                                Homicidios
                            </v-list-item-title>
                        </center>

                    </v-card>
                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="6" sm="6">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidiosJuicios != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMayores('Homicidios',3,'Juicios Orales','Colisiones-Mayores-Homicidios')" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresHomicidiosJuicios}}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidiosJuicios == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresHomicidiosJuicios}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidiosJuicios != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMayores('Homicidios',3,'Juicios Orales','Colisiones-Mayores-Homicidios')" style="font-size: 16px;  ">
                                        Juicios Orales
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidiosJuicios == 0 || !permiso" style="font-size: 16px;  ">
                                        Juicios Orales
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="6" sm="6">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidiosAve != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMayores('Homicidios',4,'Averiguación Previa','Colisiones-Mayores-Homicidios')" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresHomicidiosAve}}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidiosAve == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresHomicidiosAve}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <v-icon color="red">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidiosAve != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMayores('Homicidios',4,'Averiguación Previa','Colisiones-Mayores-Homicidios')" style="font-size: 16px;  ">
                                        Averiguación Previa
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresHomicidiosAve == 0 || !permiso" style="font-size: 16px;  ">
                                        Averiguación Previa
                                    </span>
                                </v-row>
                            </v-col>
                        </v-row>


                        <br />

                    </v-card>

                </v-col>
            </v-row>


            <!--LESIONES-->
            <v-row v-if="previewsLesiones">
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card class=" mx-1 pt-2 primary">
                        <center>
                            <v-list-item-title class="text-h5 mb-1 primary" color="white" style="color:white">
                                Lesiones
                            </v-list-item-title>
                        </center>

                    </v-card>
                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="6" sm="6">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesJuicios != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMayores('Lesiones',3,'Juicios Orales','Colisiones-Mayores-Lesiones')" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresLesionesJuicios}}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesJuicios == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresLesionesJuicios}}
                                    </span>
                                </v-row>
                                <center>
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesJuicios != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMayores('Lesiones',3,'Juicios Orales','Colisiones-Mayores-Lesiones')" style="font-size: 16px;  ">
                                        Juicios Orales
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesJuicios == 0 || !permiso" style="font-size: 16px;  ">
                                        Juicios Orales
                                    </span>
                                </center>
                            </v-col>
                            <v-col cols="6" sm="6">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesAve != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMayores('Lesiones',4,'Averiguación Previa','Colisiones-Mayores-Lesiones')" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresLesionesAve}}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesAve == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresLesionesAve}}
                                    </span>
                                </v-row>
                                <center>
                                    <v-icon color="red">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesAve != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMayores('Lesiones',4,'Averiguación Previa','Colisiones-Mayores-Lesiones')" style="font-size: 16px;  ">
                                        Averiguación Previa
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresLesionesAve == 0 || !permiso" style="font-size: 16px;  ">
                                        Averiguación Previa
                                    </span>
                                </center>
                            </v-col>
                            <!--<v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span style="font-size: 50px; color:#3364FF">
                                        14
                                    </span>
                                </v-row>
                                <center>
                                    <v-icon color="yellow">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span style="font-size: 15px;">
                                        Juicio Cívico Conciliador
                                    </span>
                                </center>
                            </v-col>-->
                        </v-row>


                        <br />

                    </v-card>

                </v-col>
            </v-row>



            <!--DAÑOS-->
            <v-row v-if="previewsDanos">
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card class=" mx-1 pt-2 primary">
                        <center>
                            <v-list-item-title class="text-h5 mb-1 primary" color="white" style="color:white">
                                Daños
                            </v-list-item-title>
                        </center>

                    </v-card>
                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosJuicios != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMayores('Daños',3,'Juicios Orales','Colisiones-Mayores-Daños')" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresDaniosJuicios}}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosJuicios == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresDaniosJuicios}}
                                    </span>
                                </v-row>
                                <center>
                                    <v-icon color="blue">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosJuicios != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMayores('Daños',3,'Juicios Orales','Colisiones-Mayores-Daños')" style="font-size: 16px;  ">
                                        Juicios Orales
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosJuicios == 0 || !permiso" style="font-size: 16px;  ">
                                        Juicios Orales
                                    </span>
                                </center>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosAve != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMayores('Daños',4,'Averiguación Previa','Colisiones-Mayores-Daños')" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresDaniosAve}}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosAve == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresDaniosAve}}
                                    </span>
                                </v-row>
                                <center>
                                    <v-icon color="red">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosAve != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMayores('Daños',4,'Averiguación Previa','Colisiones-Mayores-Daños')" style="font-size: 16px;  ">
                                        Averiguación Previa
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosAve == 0 || !permiso" style="font-size: 16px;  ">
                                        Averiguación Previa
                                    </span>
                                </center>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosJuez != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMayores('Daños',2,'Juez Cívico Conciliador','Colisiones-Mayores-Daños')" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresDaniosJuez}}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosJuez == 0 || !permiso" style="font-size: 50px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayoresDaniosJuez}}
                                    </span>
                                </v-row>
                                <center>
                                    <v-icon color="yellow">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosJuez != 0 && permiso" class="wrexlink" @click="generarTableroColisionesMayores('Daños',2,'Juez Cívico Conciliador','Colisiones-Mayores-Daños')" style="font-size: 16px;  ">
                                        Juicio Cívico Conciliador
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayoresDaniosJuez == 0 || !permiso" style="font-size: 16px;  ">
                                        Juicio Cívico Conciliador
                                    </span>
                                </center>
                            </v-col>
                        </v-row>


                        <br />

                    </v-card>

                </v-col>
            </v-row>
        </div>


    </div>


</template>

<script>
    import moment from 'moment';
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import Inicio from '@/services/main/main.service.js';


    export default {

        props: {
            tipo: 0,
            dataPendientesColision: [],
            dataPendientesRobo: []
        },
        data() {
            return {
                previewsColisiones: true,
                previewsHomicidios: false,
                previewsLesiones: false,
                previewsDanos: false,
                cont: 1,
                permiso: false
            }
        },
        computed: {
            ...mapState(['permission', 'domain']),
            ...mapGetters(['getUser', 'THEME_STATE']),
            //...mapState("Operacion", ["key"]),
            computedDate() {
                return this.date ? moment(this.date).format('Do MMM YYYY, dddd') : ''
            },
        },
        methods: {
            generarTableroRoboVHDetenidos(idproceso, PTabNombre, seccion) {
                if (this.cont == 1) {
                    this.cont++;
                    this.$router.push({ name: `tablero`, params: { proceso: idproceso, relevancia: null, aiclave: '24', PTabNombre: PTabNombre, seccion: seccion } });
                }
            },
            generarTableroColisionesMayores(relevancia, idproceso, PTabNombre, seccion) {

                //console.log(relevancia + ' ' + idproceso);
                if (relevancia == "Homicidios") {//HOMICIDIOS   3 JUICIOS ORALES, 4 AV PREVIA
                    if (this.cont == 1) {
                        this.cont++;
                        this.$router.push({ name: `tablero`, params: { proceso: idproceso, relevancia: 1, aiclave: '1', PTabNombre: PTabNombre, seccion: seccion } });
                    }
                }
                if (relevancia == "Lesiones") {//LESIONES
                    if (this.cont == 1) {
                        this.cont++;
                        this.$router.push({ name: `tablero`, params: { proceso: idproceso, relevancia: 2, aiclave: '1', PTabNombre: PTabNombre, seccion: seccion } });
                    }
                }
                if (relevancia == "Daños") {//DAÑOS
                    if (this.cont == 1) {
                        this.cont++;
                        this.$router.push({ name: `tablero`, params: { proceso: idproceso, relevancia: 3, aiclave: '1', PTabNombre: PTabNombre, seccion: seccion } });
                    }
                }

            },
            generarTableroColisionesMenores(idproceso, PTabNombre, seccion) {
                if (this.cont == 1) {
                    this.cont++;
                    this.$router.push({ name: `tablero`, params: { proceso: idproceso, relevancia: 0, aiclave: '1', PTabNombre: PTabNombre, seccion: seccion } });
                }
            },
            previstaColisiones(valor) {
                this.previewsColisiones = false;
                if (valor == 1) {
                    this.previewsHomicidios = true;
                }
                if (valor == 2) {
                    this.previewsLesiones = true;
                }
                if (valor == 3) {
                    this.previewsDanos = true;
                }
            },
            regresarPreColisiones() {
                this.previewsColisiones = true;
                this.previewsHomicidios = false;
                this.previewsLesiones = false;
                this.previewsDanos = false;
            },
            regresar() {
                this.$emit("regresardash");
            }

        },
        async mounted() {

            Inicio.VerificarPermisos(this, 314).then(response => {
                if (response.length > 0) {
                    this.permiso = true;
                }
            });
        }
 }
</script>